import { makeInstaller } from './make-installer.mjs';
import Components from './component.mjs';
import Plugins from './plugin.mjs';

var installer = makeInstaller([...Components, ...Plugins]);

export { installer as default };
//# sourceMappingURL=defaults.mjs.map
